import { render, staticRenderFns } from "./BottomSheet.vue?vue&type=template&id=674b4eb9&scoped=true&"
import script from "./BottomSheet.vue?vue&type=script&lang=js&"
export * from "./BottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheet.vue?vue&type=style&index=0&id=674b4eb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b4eb9",
  null
  
)

export default component.exports